import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { AspMyItemListService } from './asp-my-item-list.service';
import { AspCartService } from '../asp-cart/asp-cart.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ToastrService } from 'ngx-toastr';
import { AspSparesListService } from '../asp-spares-list/asp-spares-list.service';
import { AnimationOptions } from 'ngx-lottie';
import { SearchSuggestionService } from 'app/shared/search-suggestion.service';

@Component({
  selector: 'app-asp-my-item-list',
  templateUrl: './asp-my-item-list.component.html',
  styleUrls: ['./asp-my-item-list.component.scss']
})
export class AspMyItemListComponent implements OnInit {
  loading: boolean = false;  
  selectedItem: any;
  editSheetOpen: boolean;
  editingItem:any= null;
  editItemForm: UntypedFormGroup;
  vehicleData:any;
  itemList: any = [];
  cartList = [];
  cartCount: number = 0;
  cartSubTotal: number = 0;
  cartGrandTotal: number = 0;
  isCartCount:boolean = false;  
  sparesDiscount: number;
  shippingCharges: any;
  grandAmount: any;
  isMobile: boolean;
  addedCart = [];
  vehicleType:any = localStorage.getItem('vehicleType');
  newData = {};  
  amount: any;
  emptyImg:any = 'assets/images/no-cart.png';  
  Messages: any;  
  randomMessage: any;
  @ViewChild('dynamicContainers', { read: ViewContainerRef }) containers!: ViewContainerRef;
  @ViewChild('myInput') myInput!: ElementRef;
  options: AnimationOptions = {
    path: './assets/images/loader.json' // Replace with your JSON animation file URL
  };
  searchText: string = '';
  suggestions: { value: string; type: string }[] = []; 
  @ViewChild('dropdown') dropdown;
  searchTextShow: boolean= true;
  suggestions1: any;
  updatedName: any;
  data: any;
  firstSelectionDone: boolean= false;
  selected: { id: string; };
  wishlistCount: any;
  fevList: any[];
  fevCount: number;
  addWishlist: boolean;
  private hasAutoSelectedSuggestion = false;


  constructor(
    private fb: UntypedFormBuilder,
    private aspMyItemListService: AspMyItemListService,
    private aspCartService: AspCartService,    
    private breakpointObserver: BreakpointObserver,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private aspSparesListService: AspSparesListService,
    public searchSuggestionService:SearchSuggestionService,
  ) {
    this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); 
  }

  ngOnInit(): void {
 
  //  console.log('this.itemList',this.itemList);
    this.getLoadingMsg();
    this.vehicleData = JSON.parse(localStorage.getItem('vehicleData'));
    this.getItemList();
    this.editItemForm = this.fb.group({
      itemName: [''],
    });
    // this.editItemForm.get('itemName')?.valueChanges.subscribe(value => {
    //   if (value) {
    //     // this.vehicleForm.get('regNo')?.setValue(value.toUpperCase(), { emitEvent: false });
    //     const formattedValue = this.formatRegNo(value);
    //     this.editItemForm.get('regNo')?.setValue(formattedValue, { emitEvent: false });
    //   }
    // });
    this.aspMyItemListService.wishlistUpdated$.subscribe(() => {
      this.loadWishlist(); // Refresh whenever wishlist changes
    });
    this.loadWishlist();
  }
  
  get ef() { return this.editItemForm.controls; }
  loadWishlist(){
    const wishlist: any[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');

    this.itemList.forEach(item => {
      item.inWishlist = wishlist.some(w => 
        w.name && item.name && w.name.toLowerCase() === item.name.toLowerCase()
      );
    });

   this.getWishlist()
    this.updateWishlistCount();
  }

getItemList() {
  this.loading = true; 
  
  this.getCart();
  this.itemList = [];
  let searchItems = localStorage.getItem('searchItems');
  let garageKey = localStorage.getItem('garageKey');
  const relevancyCount = 3;
  
  this.aspMyItemListService
      .getSuggest(relevancyCount, this.vehicleData.variantKey, searchItems, garageKey)
      .subscribe((result) => {
      // console.log("result",result)
      this.data=result.data;
      if (result.code == 200) {
        this.loading = false; 
        const suggestionMap: { [key: string]: { name: string; id: number } } = {};

            const searchArray = Array.isArray(searchItems) ? searchItems : searchItems.split(',');

            searchArray.forEach((rawItem: string) => {
              const item = rawItem.trim().toLowerCase();
              const value = result.details[rawItem.trim()];

              if (value) {
                if (typeof value === 'object' && !Array.isArray(value)) {
                  const innerKeys = Object.keys(value);
                  const name = innerKeys.length > 0 ? innerKeys[0].trim().replace(/,/g, ' ') : rawItem.trim().replace(/,/g, ' ');
                  const id = value[innerKeys[0]];

                  suggestionMap[item] = { name, id };
                } else if (Array.isArray(value) && value.length > 0) {
                  const firstItem = value[0];
                  const name = (firstItem.name?.trim() ?? rawItem.trim()).replace(/,/g, ' ');
                  const id = firstItem.id ?? 0;

                  suggestionMap[item] = { name, id };
                }
              } else {
                const fallback = rawItem.trim().replace(/,/g, ' ');
                suggestionMap[item] = { name: fallback, id: 0 };
              }
            });

            sessionStorage.setItem("suggestionMap", JSON.stringify(suggestionMap));


        Object.entries(result.data).forEach(([key, items]) => {
          let addedToCart = false;
          if (this.cartList?.length > 0) {
            this.cartList[0] && Object.entries(this.cartList[0]).forEach(([cart_key, cart]) => {
              if ((cart['partName']||cart['name']).toLowerCase() === key.toLowerCase()) {
                addedToCart = true;
              }
            });

          }

          Object.entries(items).forEach(([item_key, item]) => {
            item.brand = {"name": item.partInfo.brand};
            item.mrp = this.getRate(item);
            item.sellingPrice = this.getSellingPrice(item);
            item.spareStocks =  {
              "partNumber": item.partInfo.partNumber,
              "quantity": 0,
              "mrp":  this.getRate(item),
              "sellingPrice": this.getSellingPrice(item),
              // "discountAmount": item.discount
            }            
          })

          // this.itemList.push({
          //   id: key.replace(/\s+/g, "_"), // Fix space issue
          //   name: key.toUpperCase(), // Keep name formatting
          //   addedToCart: addedToCart,
          //   products: items
          // });
        });
        // Handle search items
        if (searchItems) {
          let searchNames = searchItems.split(',').map(s => s.trim().toLowerCase()); // Store once
        
          searchNames.forEach(searchName => {
            const productKey = Object.keys(result.data).find(
              key => key.toLowerCase() === searchName.toLowerCase()
            );
          
            let matchedDetail: any = null;
            let suggestions: string[] = [];
          
            // Process result.details for suggestions and matchedDetail
            Object.entries(result.details).forEach(([detailKey, value]) => {
              const keyMatch = detailKey.toLowerCase() === searchName.toLowerCase();
          
              if (Array.isArray(value) && keyMatch) {
                matchedDetail = value;
                suggestions = value.map(d => d.name);
              } else if (typeof value === 'object' && value !== null) {
                const nestedMatchKey = Object.keys(value).find(
                  k => k.toLowerCase() === searchName.toLowerCase()
                );
          
                if (nestedMatchKey) {
                  matchedDetail = { [nestedMatchKey]: value[nestedMatchKey] };
                  suggestions = [nestedMatchKey];
                } else if (keyMatch) {
                  matchedDetail = value;
                  suggestions = Object.keys(value);
                }
              }
            });
          
            // Determine addedToCart based on cartList
            let addedToCart = false;
            if (this.cartList?.length > 0 && productKey) {
              this.cartList[0] &&
              Object.entries(this.cartList[0]).forEach(([cart_key, cart]) => {
                if ((cart['partName'] || cart['name']).toLowerCase() === productKey.toLowerCase()) {
                  addedToCart = true;
                }
              });
            }
            const properCaseName = searchName.replace(/\w\S*/g, txt => txt[0].toUpperCase() + txt.substring(1).toLowerCase());

            // Read session storage
            let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');

            
            // Case-insensitive comparison
            const isInWishlist = wishlist.some(w => w.name.toLowerCase() === properCaseName.toLowerCase());
            const wishlistItem = wishlist.find(w => w.name.toLowerCase() === properCaseName.toLowerCase());
            const quantity = wishlistItem ? wishlistItem.quantity : 1;
            // Push item if not already present
            if (!this.itemList.some(item => item.name.toLowerCase() === searchName.toLowerCase())) {
              this.itemList.push({
                id: searchName.replace(/\s+/g, "_"),
                name: searchName.toUpperCase(),
                addedToCart: addedToCart,
                inWishlist: isInWishlist,
                products: result.data[productKey] || [],
                wishQty:quantity,
                details: matchedDetail,
                suggestions1: suggestions,
              });
            }
          });
          
          // Auto-select if only one suggestion is available and no products
          // 🔁 Check and auto-select if exactly one item in itemList has exactly 1 suggestion and no products
          if (!this.hasAutoSelectedSuggestion) {
            const correctedTerms: string[] = [];

            this.itemList.forEach(item => {
              if (
                item.suggestions1?.length === 1 &&
                (!item.products || item.products.length === 0)
              ) {
                correctedTerms.push(item.suggestions1[0]);
              } else {
                correctedTerms.push(item.name); // keep original if no correction needed
              }
            });

            const originalSearch = (localStorage.getItem("searchItems") || "").toLowerCase().split(',').map(s => s.trim());
            const correctedSearch = correctedTerms.map(s => s.toLowerCase());

            const hasCorrection = JSON.stringify(originalSearch) !== JSON.stringify(correctedSearch);

            if (hasCorrection) {
              this.hasAutoSelectedSuggestion = true;
              localStorage.setItem("searchItems", correctedTerms.join(', '));
              this.itemList = [];
              this.getItemList(); // Recall with corrected full string
              return;
            }
          }

          // **Fixed Sorting Logic**
          this.itemList.sort((a, b) => {
            let indexA = searchNames.indexOf(a.name.toLowerCase());
            let indexB = searchNames.indexOf(b.name.toLowerCase());

            return (indexA === -1 ? searchNames.length : indexA) - (indexB === -1 ? searchNames.length : indexB);
          });
        }

        // **Select the first item only if the list is not empty**
        if (this.itemList.length > 0) {
          const matchedItem = this.itemList.find(item => item.id === this.selected?.id);
        // console.log("matchedItem",matchedItem);
        // console.log("this.selected.id",this.selected?.id)
        // console.log("this.selected.id",this.selected)

          if (matchedItem) {
            this.selectItem(matchedItem);
          } else {
            this.selectItem(this.itemList[0]);
          }
        }
      }
    }
  );
  
}



  selectItem(item: any): void {
    this.selectedItem = item;
    // console.log("selectItem", this.selectedItem)
    localStorage.setItem("selectItem",this.selectedItem['wishQty']);
  }

  increaseQuantity(product: any): void {
    product.quantity++;
  }

  decreaseQuantity(product: any): void {
    if (product.quantity > 1) {
      product.quantity--;
    }
  }
  toProperCase(text: string): string {
    return text.replace(/\w\S*/g, (word) => {
      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
  }

  openEdit(item: any) {
    this.searchText = this.toProperCase(item.name);
    this.editSheetOpen = true;
    this.editingItem = item;

    // Set the current item name into the form control
    this.editItemForm.patchValue({
      itemName: this.transform(item.name),
    });
    this.filterSuggestions();
  }

  closeEdit() {
    this.editSheetOpen = false;
    this.editingItem = null;
  }

  saveChanges() {
    this.updatedName = this.ef.itemName.value.trim(); // Ensure trimmed value
    const formattedId = this.updatedName.replace(/\s+/g, '_').toLowerCase();
    this.selected = { id:formattedId };
    // console.log(" this.selected",this.selected)
    // console.log("updatedName",this.updatedName);
    if (this.updatedName.length>0){
    let searchItems = localStorage.getItem('searchItems');

    if (searchItems) {
        let itemsArray = searchItems.split(',').map(item => item.trim()); // Ensure list format remains same

        let updatedItems = itemsArray.map(item => 
            item.toLowerCase() === this.editingItem.name.toLowerCase() ? this.updatedName : item
        );

        // Ensure we save the list in the same order
        localStorage.setItem('searchItems', updatedItems.join(','));
        // console.log('Updated search items:', updatedItems);

        // Refresh list if needed
        this.getItemList();
        this.closeEdit();
        this.searchText='';
    }
  }
  else {
    this.closeEdit();
  }
}



  // removeFromList(removeItem: any) {
  //   // this.itemList = this.itemList.filter((item) => item.id !== removeItem.id);
  //   let searchItems = localStorage.getItem('searchItems');
  //   // searchItems = searchItems.split(',').filter(item => item.toLowerCase() !== removeItem.name.toLowerCase()).join(',');
  //   searchItems = searchItems.split(',').filter(item => item.toLowerCase() !== removeItem.name.toLowerCase()) .map(item => item.replace(/\s+/g, '')).join(',');
  //   localStorage.setItem('searchItems', searchItems);
  //   this.getItemList();  
  //   this.closeEdit();
  // }

  removeFromList(removeItem: any) {
    // console.log("removeItem",removeItem);
    let searchItems = localStorage.getItem('searchItems');
    // console.log("searchItems123",searchItems);

      if (searchItems) {
        let itemsArray = searchItems.split(',');
    
        // Clean and normalize items before filtering
        let filteredItems = itemsArray
            .map(item => item.trim()) // Remove leading/trailing spaces
            .filter(item => item.toLowerCase() !== removeItem.name.toLowerCase());
    
        // console.log("Filtered Items:", filteredItems); // Now properly trimmed and filtered
    
        searchItems = filteredItems.join(',');
    }
    
        // console.log("searchItems2123",removeItem.name.toLowerCase())
        localStorage.setItem('searchItems', searchItems);
// console.log("searchItems", searchItems);
        this.getItemList();
        this.closeEdit();
}


  // cart
  addCart(items, count){
    // console.log("count",count);
    delete items.rowKey;
    delete items.variantKey;

    // if(this.isReplacePopup==true){
    //   sessionStorage.setItem('replaceCart', JSON.stringify(items));
    //   this.zone.run(() => {
    //     this.dialog.open(AspReplaceCartPopupComponent);
    //   });
    // }else{
    //   this.setNewMakeAsMake();
        
      this.addedCart = [];
      if(this.vehicleType=='universal'){
        items.type = 'universal';
      }
      if(localStorage.getItem('addedCart')){
        this.newData = JSON.parse(localStorage.getItem('addedCart'))[0];
        // console.log("items.cart_qty",items.cart_qty);
        items.cart_qty = count;
        items.key = items.partInfo.partKey;
        items.partKey = items.partInfo.partKey;
        items.name = items.partInfo.partName;
        items.partName = items.partInfo.partName;
        // items.brand=items.partInfo.brand;
        // items.partNumber= items.partInfo.partNumber;
        this.amount=items.spareStocks;
        let make = localStorage.getItem('selectedMake');
        let model = localStorage.getItem('selectedModel');
        let registrationNumber = localStorage.getItem('registrationNumber')||localStorage.getItem('regNo') ;
        let variant = localStorage.getItem('variant');
        let mfgYear = localStorage.getItem('selectedYear');
        let fuelType = localStorage.getItem('selectedFuel');
        let rowKey = localStorage.getItem('rowKey');
        let variantKey = localStorage.getItem('variantKey');
        items = {
          ...items.spareStocks, 
          ...items, 
          selectedMake: make,
          selectedModel: model,
          registrationNumber: registrationNumber,
          variant: variant,
          selectedYear: mfgYear,
          selectedFuel: fuelType, 
          rowKey: rowKey, 
          variantKey: variantKey      
        };
        items.discount= this.getRate(items)-this.getSellingPrice(items);
        this.newData[items.partInfo.partKey] = items;
        this.addedCart.push(this.newData);
        localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      }else{
        items.cart_qty = count;
        items.key = items.partInfo.partKey;
        
        items.partKey = items.partInfo.partKey;
        items.name = items.partInfo.partName;
        items.partName = items.partInfo.partName;
        items.discount= this.getRate(items)-this.getSellingPrice(items);
        // items.mrp = this.getRate(items);
        // items.brand=items.partInfo.brand;
        // items.partNumber= items.partInfo.partNumber;
        this.amount=items.spareStocks;
        let make = localStorage.getItem('selectedMake');
        let model = localStorage.getItem('selectedModel');
        let registrationNumber = localStorage.getItem('registrationNumber')||localStorage.getItem('regNo');
        let variant = localStorage.getItem('variant');
        let mfgYear = localStorage.getItem('selectedYear');
        let fuelType = localStorage.getItem('selectedFuel');
        let rowKey = localStorage.getItem('rowKey');
        let variantKey = localStorage.getItem('variantKey');
        items = {
          ...items.spareStocks, 
          ...items,
          selectedMake: make,
          selectedModel: model,
          registrationNumber: registrationNumber,
          variant: variant,
          selectedYear: mfgYear,
          selectedFuel: fuelType,
          rowKey: rowKey, 
          variantKey: variantKey      
        };

        
        items.discount= this.getRate(items)-this.getSellingPrice(items);
        this.newData[items.partInfo.partKey] = items;
        this.addedCart.push(this.newData);
        localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
        // console.log("this.addedCart",this.addedCart)
      }      
      this.getCart();
    // }
  }

  getCart(){
    let cartData;  
    this.cartList = [];
    this.cartCount = 0;
    this.cartSubTotal = 0;
    this.cartGrandTotal = 0;
    
    if(localStorage.getItem('addedCart')){   
      cartData = JSON.parse(localStorage.getItem('addedCart'));
      if(Object.keys(cartData[0]).length==0){
        this.isCartCount = false;
      } 
      Object.values(cartData[0]).forEach(cart => { 
        if(cart){
          this.isCartCount = true;
          this.cartCount++;
        

        // this.cartCount += cart['cart_qty'];
        if(cart['sellingPrice']>0){
          this.cartSubTotal += (cart['sellingPrice']*cart['cart_qty']);
        }else{
          this.cartSubTotal += (cart['mrp']*cart['cart_qty']);
        }
        this.cartList.push(cart);
        
      }
      });      

      this.cartList = cartData;
      this.cartGrandTotal = this.cartSubTotal;
      // console.log(this.cartList);

      if(this.cartCount>0){
        (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
      }else{
        (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
      }
      if(this.sparesDiscount>0){
        this.cartGrandTotal = (this.cartSubTotal - this.sparesDiscount);
      }else{
          this.cartGrandTotal = this.cartSubTotal;
      }
      // this.getShippingCharges();  
    }
    // console.log("cartList",this.cartList)
  }

  getShippingCharges(){    
    // this.loading = true; 
    let garageKey = localStorage.getItem('garageKey');
    this.aspCartService.getShippingCharges(this.cartGrandTotal, garageKey).subscribe(
      result => {
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          // this.shippingChargesApplicable = res.data.shippingChargesApplicable;
          this.shippingCharges = res.data.shippingCharges;
          // this.avoidShippingCharges = res.data.avoidShippingCharges;
          this.grandAmount= res.data.cartValue;
          // this.loading = false;
            this.cartGrandTotal = this.grandAmount+this.shippingCharges;
  
            if(!this.isMobile){
              if(this.cartCount>0){
                (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
              }else{
                (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
              }
            }else{
              if(this.cartCount>0){
                (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.cartCount+'</div>';
              }else{
                (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
              }
            }            
          
        } else {
          if(!this.isMobile){
            if(this.cartCount>0){
              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = ''+this.cartCount+' items <div class="right-amount-carts">₹'+this.cartGrandTotal.toFixed(2)+'</div>';
            }else{
              (document.getElementsByClassName('cart_count_num')[0] as HTMLInputElement).innerHTML = 'My Cart';
            }
          }else{
            if(this.cartCount>0){
              (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.cartCount+'</div>';
            }else{
              (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
            }
          }
        }
      }
    );
  }

  removeItem(count, item){ 
    this.addedCart = [];    
    let data;
    
    data = JSON.parse(localStorage.getItem('addedCart'))[0];
    if(count>1){
      let countval = count-1;
      data[item].cart_qty = countval;      
      data[item].key = data[item].partKey;

      if(this.vehicleType=='universal'){
        data[item].type = 'universal';
      }

      this.addedCart[0] = data;
      localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      this.getCart();
    }else{
      this.deleteItem(item);
      this.toastr.error(data[item].partName+' removed from cart', 'Cart Item');
    }
  }

  addItem(count, item){
    let countval = count+1;
    
    // this.addCart(item,countval);
    this.addedCart = [];
    let data;
    
    // data = JSON.parse(localStorage.getItem('addedCart'))[0];
    // if(countval<=data[item].spareStocks.quantity){
    //   data[item].cart_qty = countval;

    //   if(this.vehicleType=='universal'){
    //     data[item].type = 'universal';
    //   }

    //   this.addedCart[0] = data;
    //   localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
    //   this.getCart();
    // }else{
    //   this.toastr.error('Only '+data[item].spareStocks.quantity+' unit available for this item', 'Error');
    // }
    data = JSON.parse(localStorage.getItem('addedCart'))[0];
    // if(countval<=data[item].spareStocks.quantity){
      data[item].cart_qty = countval;
      data[item].key = data[item].partKey;
      this.addedCart[0] = data;
      // console.log("this.addedCart",this.addedCart)
      localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
      this.getCart();
  }

  deleteItem(item){
    this.newData = {};
    let cartData;

    cartData = JSON.parse(localStorage.getItem('addedCart'));
    Object.values(cartData[0]).forEach(cart => { 
      if(cart['partKey']!=item) {
        this.newData[cart['partKey']] = cart;
      }
    });
    
    this.addedCart[0] = this.newData;
    localStorage.setItem('addedCart', JSON.stringify(this.addedCart));
    this.getCart();
    // console.log(this.addedCart);
    
  }
  // end cart


  // loading
  getLoadingMsg() {
    this.aspSparesListService.getLoadingMsg().subscribe(
      result => {

        let res = JSON.parse(JSON.stringify(result));
        this.Messages = res.data.appLoadingMessages;
  
        // Call getRandomMessage only after the Messages array is populated
        this.getRandomMessage();
        this.cdr.detectChanges();
      },
      error => {
        // console.error('Error fetching loading messages', error);
      }
    );
  }
  
  getRandomMessage() {
    if (this.Messages && this.Messages.length > 0) {
      const randomIndex = Math.floor(Math.random() * this.Messages.length);
      this.randomMessage = this.Messages[randomIndex];
    } else {
      // console.error('No messages available to pick from');
    }
  }

  animationCreated(animationItem: any): void {
    // Animation is created and can be interacted with here
  }

  // End loading


  transform(value: string): string {
    if (!value) return value;
    return value
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }


 
selectedSuggestion: string | null = null;

selectSuggestion(id: string, item) {
  // console.log("suggestion",id);
  // console.log("item",item);
  this.selectedSuggestion = id;
  this.ef.itemName.setValue(id); // update form control
  this.editingItem= item;
  this.saveChanges();

}

filterSuggestions() {
  if (this.searchText && this.searchText.length >= 3) {
    
    this.searchTextShow=true;
      let rowKey = localStorage.getItem('rowKey');
      
      let universal = false;
      let variantKey = localStorage.getItem('variantKey');
      // console.log("searchText",this.searchText);
      this.searchSuggestionService.getSearchSuggestions(rowKey, this.searchText, universal, variantKey).subscribe(
          result => {

// console.log("result", result);
              this.suggestions = [];
              // if (result['data'].brands && result['data'].brands.length > 0)
              //     this.suggestions.push(...result['data'].brands.map((value: string) => ({ value, type: 'brand' })));
              // if (result['data'].categories && result['data'].categories.length > 0)
              //     this.suggestions.push(...result['data'].categories.map((value: string) => ({ value, type: 'category' })));
              if (result['data'].partNames && result['data'].partNames.length > 0)
                  this.suggestions.push(...result['data'].partNames.map((value: string) => ({ value, type: 'partName' })));
              // if (result['data'].partNumbers && result['data'].partNumbers.length > 0)
              //     this.suggestions.push(...result['data'].partNumbers.map((value: string) => ({ value, type: 'partNumber' })));

              this.suggestions.reverse();
              // Sort suggestions based on relevance
              this.suggestions = this.sortSuggestionsByRelevance(this.suggestions, this.searchText);

          }
      );
  } else {
      this.suggestions = [];
  }
}
sortSuggestionsByRelevance(suggestions: { value: string, type: string }[], searchText: string): { value: string, type: string }[] {
  const typePriority = {
      brand: 4,
      category: 3,
      partName: 2,
      partNumber: 1,
  };

  return suggestions?.sort((a, b) => {
      const relevanceA = this.getRelevance(a.value, searchText) + typePriority[a.type];
      const relevanceB = this.getRelevance(b.value, searchText) + typePriority[b.type];

      return relevanceB - relevanceA; 
  });
}
getRelevance(suggestion: string, searchText: string): number {
  if (suggestion?.toLowerCase() === searchText?.toLowerCase()) {
      return 3; 
  } else if (suggestion?.toLowerCase().startsWith(searchText?.toLowerCase())) {
      return 2; 
  } else if (suggestion?.toLowerCase().includes(searchText?.toLowerCase())) {
      return 1; 
  } else {
      return 0; 
  }
}
getHighlightedText(text: any, search: any): string {
  if (typeof text !== 'string' || typeof search !== 'string') {
      // Handle cases where text or search is not a string
      return text;
  }

  if (!search) {
      return text; // Return original text if no search term
  }

  const parts = text.split(new RegExp(`(${search})`, 'gi'));
  return parts.map(part => part.toLowerCase() === search.toLowerCase()
      ? `<span class="highlight">${part}</span>`
      : part
  ).join('');
}
isFirstSuggestion(suggestion: string, index: number): boolean {
  // Check if it's the first suggestion and if it matches preSearchValue
  let preSearchValue=localStorage.getItem('preSearchValue');
  return index === 0 && preSearchValue === suggestion['value'];
}

getDiscount(product: any): number | null {
  if (!product.zohoPartPrice || !product.partInfo.partNumber) return null;

  const matched = product.zohoPartPrice.find(
    (p: any) => p.sku === product.partInfo.partNumber
  );

  return matched ? matched.discount : null;
}
getSellingPrice(product: any): number | null {
  const partNumber = product.partInfo?.partNumber;
  const matched = product.zohoPartPrice?.find(
    (p: any) => p.sku === partNumber
  );

  if (matched && matched.rate != null) {
    const { rate, discount = 0 } = matched;
    const finalPrice = +(rate - (rate * discount / 100)).toFixed(2);
    return finalPrice;
  }

  const mrp = product.partInfo?.mrp;

  if (mrp != null && !isNaN(mrp)) {
    const fallbackPrice = +(mrp / 100).toFixed(2);
    return fallbackPrice;
  }

  return null;
}


getRate(product: any): number | null {
  const matched = product.zohoPartPrice?.find(
    (p: any) => p.sku === product.partInfo?.partNumber
  );

  if (matched && matched.rate != null) {
    return +matched.rate.toFixed(2); // Round to 2 decimals
  }

  const mrp = product.partInfo?.mrp;
  if (mrp != null && !isNaN(mrp)) {
    return +(mrp / 100).toFixed(2); // Fallback to MRP divided by 100
  }

  return null; // No valid rate available
}

selectSuggestion1(suggestion: string) {
  this.selectedSuggestion = suggestion;
  // console.log("suggestion",suggestion)
  this.searchText=suggestion['value'];
  // console.log("searchText",this.searchText);
  this.searchTextShow=false;
  setTimeout(() => {
    this.myInput.nativeElement.focus();
  });
}
closeText(){
  this.searchText='';
  this.filterSuggestions();
}
toggleWishlist(item: any): void {
  if(this.fevCount <= 0){
    this.addWishlist=true;
  }
  // console.log("item", item);
  const name = item.name.trim(); // Assumes item.name is already in proper case like 'Clutch Master Cylinder'
  let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');

  // Check if the item is already in the wishlist
  const index = wishlist.findIndex(w => w.name.toLowerCase() === name.toLowerCase());

  if (index > -1) {
    // If exists: remove from wishlist
    wishlist.splice(index, 1);
    item.inWishlist = false;
  }else {
    // If the item doesn't exist, add it with quantity 1
    wishlist.push({ name: name, quantity: 1 });
    item.inWishlist = true;
  }

  // Store the updated wishlist with both name and quantity
  sessionStorage.setItem('wishlist', JSON.stringify(wishlist));

  this.updateWishlistCount();
  this.getWishlist()
}


updateWishlistCount(): void {
  const wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
  // console.log('Updated Wishlist Count:', wishlist.length);
}
increaseQty(item: any): void {
  const name = item.name.trim();
  let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');

  const existingItem = wishlist.find(w => w.name.toLowerCase() === name.toLowerCase());

  if (existingItem) {
    existingItem.quantity += 1;
  } else {
    wishlist.push({ name, quantity: 1 });
  }

  sessionStorage.setItem('wishlist', JSON.stringify(wishlist));
  this.updateWishlistCount();
  this.getWishlist();
}

decreaseQty(item: any): void {
  const name = item.name.trim();
  let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');

  const index = wishlist.findIndex(w => w.name.toLowerCase() === name.toLowerCase());

  if (index > -1) {
    // Decrease the quantity first
    wishlist[index].quantity -= 1;
    item.quantity = wishlist[index].quantity; // Update UI

    if (wishlist[index].quantity <= 0) {
      wishlist.splice(index, 1); // Remove item if quantity is 0
      item.inWishlist = false;   // Update UI state
    }

    sessionStorage.setItem('wishlist', JSON.stringify(wishlist));
  }

  this.updateWishlistCount();
  this.getWishlist();
}


getItemQuantity(name: string): number {
  const wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
  const existingItem = wishlist.find(w => w.name.toLowerCase() === name.toLowerCase());
  return existingItem ? existingItem.quantity : 1;
}

getWishlist(){
  // console.log("sessionStorage.getItem('wishlist')",sessionStorage.getItem('wishlist'))
  if(sessionStorage.getItem('wishlist')){    
    let fevData;  
    this.fevList = [];
    this.fevCount = 0;
    this.sparesDiscount = 0;
    fevData = JSON.parse(sessionStorage.getItem('wishlist'));
    // Object.values(fevData[0]).forEach(fev => { 
    //   this.fevCount += fev['quantity'];
      
    //   this.fevList.push(fev);
    // });
    if (Array.isArray(fevData)) {
      this.fevList = fevData;
      this.fevCount = fevData.length; // Count of unique items only
      // console.log("Number of unique items:", this.fevCount);
    }
    
// console.log("this.fevCount",this.fevCount)
if (!this.isMobile) {
  const badge = document.getElementsByClassName('autoscore-badge1')[0] as HTMLElement;
  if (this.fevCount > 0) {
    badge.style.display = 'block'; // Show it
    badge.innerHTML = `${this.fevCount} <div class="right-amount-fev"></div>`;
  } else {
    badge.style.display = 'none'; // Hide completely (no space)
  }
} else {
  const badgeMobile = document.getElementsByClassName('cart_count_mobile')[0] as HTMLElement;
  if (this.fevCount > 0) {
    badgeMobile.innerHTML = `<div class="cart_count">${this.fevCount}</div>`;
  } else {
    badgeMobile.innerHTML = '';
  }
}

    // this.getShippingCharges()
    // console.log(this.cartList);
    
  }
  else{
    
    this.fevCount = 0;
    if(!this.isMobile){
      if(this.fevCount>0){
        (document.getElementsByClassName('autoscore-badge1')[0] as HTMLInputElement).innerHTML = ''+this.fevCount+' items <div class="right-amount-fev">'+'Added to Wishlist'+'</div>';
      }else{
        
        (document.getElementsByClassName('autoscore-badge1')[0] as HTMLInputElement).innerHTML = 'My Wishlist';
      }
    }else{
      if(this.fevCount>0){
        (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '<div class="cart_count">'+this.fevCount+'</div>';
      }else{
        (document.getElementsByClassName('cart_count_mobile')[0] as HTMLInputElement).innerHTML = '';
      }
    }
  }
}
closePopup(){
   this.addWishlist=false;
}
yesPopup(){

  let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');

  for (let item of this.itemList) {
    const name = item.name?.trim();
    const productsLength = item.products?.length || 0;


    if (productsLength <= 0) {
      const index = wishlist.findIndex(w => w.name.toLowerCase() === name.toLowerCase());

      if (index === -1) {
        wishlist.push({ name: name, quantity: 1 });
        item.inWishlist = true;
      } 
    }
  }

  sessionStorage.setItem('wishlist', JSON.stringify(wishlist));

  this.updateWishlistCount();
  this.getWishlist();
  this.addWishlist=false;
}
}
